import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const UserComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  return (
    <CRUD
      cssClass="modalRight"
      isModal={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Roles") ?? ""}
      getRecordsPath={`organization/roles?OrganizationId=${user.OrganizationId}`}
      addEditRecordPath={`organization/AddEditRole?CurrentUserId=${window.location.host}`}
      deleteRecordPath="organization/RoleDelete"
      fieldsList={[

        {
          name: "name",
          title: t("Name"),
        },

      ]}
      fields={[{
        name: "id",
        htmlType: "hidden",
        dbType: "string",
      },
      {
        name: "name",
        htmlType: "text",
        dbType: "string",
        title: t("Name") ?? "",
        containerClass: "col-12 col-md-6",
        required: true,
      },

      {
        name: "organizationId",
        htmlType: "hidden",
        dbType: "string",
        //title: t("value")??"",
        containerClass: "col-6",
        required: true,
        value: user.OrganizationId,
      },

      ]}
    />
  )
}

export default UserComponent
